import React from 'react';
import './InfoPanel.scss';
import { IconInfoCircle } from '../../assets/icons';

interface InfoPanelProps {
    title?: any;
    alert?: any;
}

export const InfoPanel: React.FC<InfoPanelProps> = (props) => {
    const { title, alert } = props;
    const children = React.Children.toArray(props.children);

    return (
        <div className="panel info-panel">
            <h3 tabIndex={0} className="body-bold-m info-title">
                {title}
            </h3>

            <div className="divider-row info-cards">
                {children.map((child, i) => {
                    return (
                        <div className="divider-child" key={i}>
                            {child}
                        </div>
                    );
                })}
            </div>

            <div className={`info-alert ${!alert && 'invisible'}`}>
                <div className="info-alert-icon">
                    <IconInfoCircle />
                </div>
                <span className={'body-xs'} tabIndex={0}>
                    {alert}
                </span>
            </div>
        </div>
    );
};
